module.exports = __webpack_public_path__ + "static/works-002-5e813700542339e705727dda3712325f.jpg";